import { TitleCasePipe } from '@angular/common';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AbstractPurchasingService } from '../services/abstract-purchasing.service';

export const purchaseTitleResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot) => {
  const purchasingService = inject(AbstractPurchasingService);
  const purchaseId = route.paramMap.get('purchaseId');

  if (!purchaseId) {
    return of('Mapa De Cotação');
  }

  const pipe = new TitleCasePipe();

  return purchasingService.findPurchaseById(purchaseId).pipe(
    map(
      response => (response.body?.title && pipe.transform(response.body.title)) || 'Solicitação De Compra'
    ),
    catchError(() => of('Solicitação De Compra'))
  );
};
